import trialScoreShot from '@assets/projects/trial-score.jpg';
import holohuntsShot from '@assets/projects/holohunts.jpg';

export default [
  {
    name: 'Trial Score',
    description: 'Case & hearing tracker for attorneys — urgency-coded deadlines on a live dashboard.',
    tags: ['React', 'Node', 'Express', 'SQLite'],
    github: 'https://github.com/Danny-Nguyen/docketadmin',
    live: 'https://trial-score.com',
    image: trialScoreShot,
    fallback: null,
  },
  {
    name: 'HoloHunts',
    description: 'Pokémon pack-opening simulator with pull stats, hit banners, and saved history.',
    tags: ['React', 'Vite', 'IndexedDB'],
    github: 'https://github.com/Danny-Nguyen/holohunts',
    live: 'https://holohunts.com',
    image: holohuntsShot,
    fallback: null,
  },
  {
    name: 'DinoCo',
    description: 'Travel-budgeting web app built on the Flask framework.',
    tags: ['Python', 'Flask', 'JS'],
    github: 'https://github.com/lnguyen96/CSCI-4448/tree/master/Project/Travel_App',
    live: null,
    image: null,
    fallback: { glyph: '✈' },
  },
  {
    name: 'Match Messaging',
    description: 'Realtime chat that matches users by shared interests.',
    tags: ['JavaScript', 'Firebase'],
    github: 'https://github.com/TeamEpyk/MatchMessaging',
    live: null,
    image: null,
    fallback: { glyph: '💬' },
  },
  {
    name: 'League of Legends Simulator',
    description: 'Simulates matches and mechanics from the popular game League of Legends.',
    tags: ['Python'],
    github: 'https://github.com/Danny-Nguyen/Projects/tree/master/Nguyen_Project2',
    live: null,
    image: null,
    fallback: { glyph: '🎮' },
  },
  {
    name: 'Baseball Player Stats',
    description: 'Compared data structures to efficiently store and search all MLB players.',
    tags: ['C++', 'Data Structures'],
    github: 'https://github.com/Danny-Nguyen/Projects/tree/master/FinalProject_CSCI2270',
    live: null,
    image: null,
    fallback: { glyph: '⚾' },
  },
  {
    name: 'Drone Rescue Mission',
    description: 'Autonomous drone that uses path-planning algorithms to navigate its environment.',
    tags: ['Java', 'Algorithms'],
    github: 'https://github.com/Jetanat/Drone-Rescue-Mission',
    live: null,
    image: null,
    fallback: { glyph: '🚁' },
  },
];



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js